import type { ReactElement } from 'react'

export type CarouselsType = {
  id: number | string
  imgCard: string
}

export type CategoryCardType = CarouselsType & {
  price: number
  priceColor: string
  prefix?: string
  title: string
}

export type AchievementsType = CarouselsType & {
  title: string
}

export type CarouselBiggestType = CarouselsType & {
  won: number
  date: string
}

export type CarouselFavoriteType = CarouselsType & {
  time: number
  wagered: number
  profit: number
}

export type CarouselRecentlyType = CarouselsType & {
  date: string
  wagered: number
  profit: number
}

export type ContentsType = {
  id: string
  title?: ReactElement | undefined
  items: CarouselsType[]
}

export type HistoryDataType = {
  color: string
  value: string | number
}

export type HistoryTableType = {
  id: number
  data: HistoryDataType[]
}

export type EquipItemType = {
  equipImg: string
  part: string
  rarity: string
  rewards: string
}

export type RewardsRankItemType = {
  rankImg: string
  text: string
  success: boolean
}

export type CoinsType = {
  coinImg: string
  coinName: string
  description: string
}

export type AccountTabItemType = {
  iconName: string
  itemName: string
  value: string
}

export type SessionType = {
  id: number
  browser: string
  near: string
  ip: string
  lastUse: string
  action: string
}

export type GameChallengesCardType = CarouselsType & {
  description: string
  prizePot: number
  userAvatar: string
  username: string
}

export type VipLevelType = {
  id: number
  rankUrl: string
  title: string
  textColor: string
  bgColor: string
  exp: number
  privileges: PrivilegeType
}

export type PrivilegeType = {
  level: string
  rakeback: string
  rankUpBonus: boolean
  dailyBonus: boolean
  weeklyBonus: boolean
  monthlyBonus: boolean
  reloadBonus: boolean
  vipHost: boolean
  sponsoredBattles: boolean
  customizedBenefits: boolean
}

export type LootBoxesLuckyItemType = {
  id: number | string
  name: string
  giftUrl: string
  code?: string
  price: number
}

export type LootBoxesItemCardType = {
  id: number | string
  name: string
  rate: number
  giftUrl: string
  rare?: string
  code: string
  price: number
}

export type AddPaymentFormType = {
  cardNumber: string
  nameOfCard: string
  expiryDate: string
  cvv: string
  savePayment: boolean
}

export type PaymentItemProps = {
  checked: boolean
  value: string
  paymentName: string
  endCode: string
  handleClick: () => void
}

export enum DIALOG {
  ADD_PAYMENT = 'add',
  EDIT_PAYMENT = 'edit',
  DEL_PAYMENT = 'delete',
}

export type InfoPaymentDialogProps = {
  openDialog: DIALOG | null
  setOpenDialog: (modal: DIALOG | null) => void
}

export type SocialLinkItemType = {
  iconClassName: string
  title: string
  active: boolean
}
